// HOOKS
import { useContext, useEffect } from 'react'
import useFetch from 'hooks/useFetch'

// COMPONENTS
import MailsCompGrid from 'components/Mails/MailsCompGrid'
import { toast } from 'react-toastify'

// CONTEXTS
import { useLocation } from 'wouter'
import { TitleContext } from 'contexts/TitleContext'
import { ModalContext } from 'contexts/ModalContext'

// ASSETS
import loadingIco from 'components/ui/Logo/loading_azul.gif'

export default function MailsViewGrid() {
  // Contextos
  const [, setLocation] = useLocation()
  const { setTitle } = useContext(TitleContext)
  const { openModal } = useContext(ModalContext)

  // useFetch():
  const [getApiCallGet, setApiCallGet] = useFetch()
  const [getApiCallDelete, setApiCallDelete] = useFetch()

  // ############################################################

  // CRUD: GET
  useEffect(() => {
    if (!getApiCallDelete.error) {
      // Llamada Api GET:
      const apiCallGet = {
        url: 'mails',
        method: 'GET',
        messageKo: '¡Error cargando Facturas!'
      }
      setApiCallGet(apiCallGet)
    }
  }, [getApiCallDelete.data])

  // * Recoger datos API: GET
  useEffect(() => {
    // Título de la página:
    const title = {
      name: `Facturas`,
      buttons: [
        {
          name: 'Nueva Factura',
          link: `/mails/new`
        }
      ],
      button: 'print',
      export: true,
      csvData: getApiCallGet.data
    }
    setTitle(title)
  }, [getApiCallGet.data])

  // ############################################################

  // CRUD: DELETE
  const handleDelete = async (id) => {
    const apiCallDelete = {
      url: `mails/${id}`,
      method: 'DELETE'
    }
    await setApiCallDelete(apiCallDelete)
  }

  // * Mostrar mensaje API:DELETE
  // ! Mostrar error API: DELETE
  useEffect(() => {
    if (getApiCallDelete.isCalled) {
      handleLoadingModal(
        getApiCallDelete.loading,
        `/mails/grid`,
        'Eliminando facturas... ¡En unos segundos estarán eliminadas!',
        getApiCallDelete.error,
        getApiCallDelete.message,
        true
      )

      const successMessage = (message) =>
        toast.success(message, {
          position: toast.POSITION.TOP_CENTER
        })

      const errorMessage = (error) =>
        toast.error(error, {
          position: toast.POSITION.TOP_CENTER
        })

      if (getApiCallDelete.message) {
        successMessage(getApiCallDelete.message)
        setLocation('/mails/grid')
      }

      if (getApiCallDelete.error) {
        errorMessage(getApiCallDelete.error)
        setLocation('/mails/grid')
      }
    }
  }, [getApiCallDelete.loading])

  // ############################################################

  // Modal cargando cambios:
  const handleLoadingModal = (
    isLoading,
    url,
    message,
    apiCallError,
    apiCallMessage,
    isSync
  ) => {
    const modalData = {
      isLoading,
      url,
      message,
      isSync,
      apiCallError,
      apiCallMessage,
      type: 'LOADING'
    }

    openModal(modalData)
  }

  // ############################################################

  // 'handleClick()' para cada item en una lista, al pulsar un item nos llevará a la ruta especificada en el 'setLocation':
  const handleClick = (e, item) => {
    e.preventDefault()
    setLocation(`/mails/${item.Mails_Id}/mail-split`)
  }

  return getApiCallGet?.data && !getApiCallGet.loading ? (
    <div className="md:flex">
      <div
        className={`w-full ${
          getApiCallGet.data.length > 0 ? 'block' : 'hidden'
        }`}
      >
        <div className="flex flex-col">
          <MailsCompGrid
            items={getApiCallGet.data}
            handleClick={handleClick}
            handleDelete={handleDelete}
          />
        </div>
      </div>

      <div
        className={`w-full ${
          getApiCallGet.data.length > 0 ? 'hidden' : 'block'
        }`}
      >
        <div className="flex flex-col">
          <div
            className="bg-red-100 border-t-4 border-red-500 rounded-b text-red-900 px-4 py-3 shadow-md"
            role="alert"
          >
            <div className="flex">
              <div className="py-1">
                <svg
                  className="fill-current h-6 w-6 text-red-500 mr-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                </svg>
              </div>
              <div>
                <p className="font-bold">¡La bandeja de entrada está vacía!</p>
                <p className="text-sm">No se han enviado correos.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div>
      <div className="h-full w-full flex justify-center items-center content-center">
        <p
          className="h-full text-blue-700 font-extrabold flex justify-center flex-col-reverse items-center"
          title="Cargando..."
        >
          ¡Cargando!
          <div className="mt-16 mb-8" style={{ width: '75px', height: '75px' }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
              <style>
                {`
                  @keyframes zoomInOut {
                    0%, 100%, 5%, 95% {
                      transform: translate(50px, 50px) scale(0);
                    }
                    20%, 80% {
                      transform: translate(10px, 10px) scale(.8);
                    }
                  }
                  
                  @keyframes spin {
                    from {
                      transform: rotate(0);
                    }
                    to {
                      transform: rotate(360deg);
                    }
                  }
                `}
              </style>

              <defs>
                <mask id="Mask">
                  <circle cx="50" cy="50" r="50" fill="#fff"></circle>
                  <circle
                    cx="50"
                    cy="50"
                    r="50"
                    style={{
                      animationName: 'zoomInOut',
                      animationDuration: '5.2s',
                      animationIterationCount: 'infinite',
                      animationTimingFunction: 'linear'
                    }}
                  ></circle>
                </mask>
              </defs>

              <g
                style={{
                  animationName: 'spin',
                  animationDuration: '1.3s',
                  transformOrigin: 'center',
                  animationIterationCount: 'infinite',
                  animationTimingFunction: 'linear'
                }}
                fill="#1C69D4"
                mask="url(#Mask)"
              >
                <path d="M0 0h50v50H0zM50 50h50v50H50z"></path>
              </g>
            </svg>
          </div>
        </p>
      </div>
    </div>
  )
}
